import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum RefComponentsNamespaceErrorCode {
  UnableToFindComponentBySelector = 'UnableToFindComponentBySelector',
  UnableToGetHiddenNoneRefComponents = 'UnableToGetHiddenNoneRefComponents',
  UnableToFindRefComponent = 'UnableToFindRefComponent',
}

class RefComponentsNamespaceError extends BaseError<RefComponentsNamespaceErrorCode> {
  state: Partial<{
    componentId: string;
    selector: string;
    rootComponentId: string;
  }> = {};

  constructor(message: string, code: RefComponentsNamespaceErrorCode) {
    super(message, code, 'EP RefComponentsNamespace Error');
  }

  withComponentId(componentId: string) {
    this.state.componentId = componentId;
    return this;
  }

  withSelector(selector: string) {
    this.state.selector = selector;
    return this;
  }

  withRootComponentId(rootComponentId: string) {
    this.state.rootComponentId = rootComponentId;
    return this;
  }
}

export const createRefComponentsError = createErrorBuilder<
  RefComponentsNamespaceErrorCode,
  RefComponentsNamespaceError
>(RefComponentsNamespaceError);
